module.exports = __webpack_public_path__ + "assets/media/arrow.380422cd.svg";


//////////////////
// WEBPACK FOOTER
// ./src/layouts/ChatPreview/arrow.svg
// module id = 2590
// module chunks = 0